export default {
  gnb: {
    name: 'リワードポイント',
    menu: {
      point: 'ポイント',
      withdrawInfo: '出金情報',
      faq: 'FAQ',
      pointHistory: 'ポイント履歴',
      pointExchangeHistory: 'ポイント出金履歴',
      userAuth: '本人確認情報',
    },
    login: 'ログイン',
    logout: 'ログアウト',
  },
  fnb: {
    menu: {
      pointHistory: 'ポイント履歴',
      pointExchangeHistory: 'ポイント出金履歴',
    },
  },
  footer: {
    useOfTerms: '利用規約',
    userPolicy: 'プライバシーポリシー',
    operationPolicy: '運営ポリシー',
  },
  common: {
    title: '保有ポイント',
    pointRedemptionInfo: 'ポイント交換のご案内事項',
    textExpire: '当月失効予定金額',
    textExpireGlobal: '失効予定金額',
    textExpiryInSettlement: '当月失効予定金額 - 精算中',
    textLost: '{date} 失効',
    textInfo: 'ポイント出金方法を確認する',
    btnExchange: '出金申請',
    btnSearch: '照会',
    btnDesc: '詳細履歴',
    confirm: '確認',
    cancel: 'キャンセル',
    next: '次へ',
  },
  date: {
    selectMonth: '期間選択',
    year: '年',
    month: '月',
    middle: ' から ',
  },
  // page - intro
  intro: {
    title: 'リワードポイントサービス',
    desc: `ポイントが現金で<br>キャッシュバックされる<br>リワードポイントサービス`,
    title_list: 'リワードポイント',
    default_text: 'リワードポイントサービスがありません。',
    initial_text: 'ログイン後、リワードポイントを確認してください。',
  },
  // page - 포인트 내역
  pointHistory: {
    statusList: ['積立', '使用', 'キャンセル'],
    earn: 'NEXON クリエイターズ 積立',
    chargeCampaignPoint: 'NEXON CREATORS CAMPAIGN 積立',
    rewardPoint: 'リワードポイント 積立',
    chargeNConnectReward: 'N-CONNECT Reward',
    cancelEarn: 'NEXON クリエイターズ 積立キャンセル',
    chargeCampaignPointMinus: 'NEXON CREATORS CAMPAIGN 積立キャンセル',
    lostPoint: 'ポイント失効',
    expiredPoint: 'ポイント有効期限切れ',
    requestExchangePoint: 'ポイント出金申請',
    withdrawPersonBalance: 'ポイント出金済',
    cancelRequestExchangePoint: 'ポイント出金申請({date} 申請) 送金キャンセル',
    businessRegularProfit: '事業者 {year}年 {month}月定期収益',
    withdrawBusinessBalance: '事業者残高出金',
    cancelBusinessRegularPayment: '事業者 {year}年 {month}月定期収益支払いキャンセル',
    chargeLiveDonation: 'ポイント付与',
    chargeLiveDonationMinus: 'ポイント回収',
    pointsIssued: 'ポイント付与',
    pointsReclaim: 'ポイント回収',
    expiryDate: '有効期限',
    plus: '積立',
    minus: '使用',
    cancel: 'キャンセル',
    subContentExtra: {
      cancelChargeByRefund: '返金による積立キャンセル',
      withdrawCreator: 'クリエイター登録キャンセル',
      resetIdentifyVerification: '本人認証初期化',
      failWithdrawal: '出金失敗',
      cancelGlobalExchangeRequest: 'ポイント交換エラー',
      creatorSanction: 'クリエイター制裁',
      policyViolation: '運営ポリシー違反',
      // pointTransferOperations: 'ポイント付与',
      // pointTransferAccountHolderChange: 'ポイント付与',
      pointTransferOperations: '運営によるポイント移行',
      pointTransferAccountHolderChange: 'アカウント名義変更によるポイント移行',
    },
  },
  // page - 포인트 전환 내역
  exchangeHistory: {
    statusList: ['全体 ', '申請', '処理準備中', '申請キャンセル', '処理中', '支給完了', '支給エラー', '支給取消'], // krpc
    globalStatusList: [
      '全体 ',
      '申請',
      '進行中',
      '支給エラー',
      '支給完了',
      '支給取消',
      '申請キャンセル',
      'システムエラー',
    ], // global(krpc 외 계정)
    globalStatusRow: ['申請', '進行中', '支給完了', '申請キャンセル', '支給取消', '支給エラー', 'システムエラー'], // 포인트 전환 내역에 뜨는 상태
    caution: {
      title: '事業者会員に関する注意事項',
      content: `
        <li>事業者会員の前月獲得ポイントは毎月1日に支払い額が確定し、ポイント交換履歴が自動的に作成されます。</li>
        <li>詳細履歴をご確認後、確定金額に対して電子税金計算書を発行していただくことで収益が支払われます。</li>
        <li>電子税金計算書は毎月25日までに<a href="mailto:rewardpoint_tax@nexon.co.kr">rewardpoint_tax@nexon.co.kr</a>までお送りください。</li>
        <li>税金計算書が未発行の場合は、収益支払いのキャンセルまたはポイントが失効することがあります。</li>`,
      global: {
        title: 'ご案内事項',
        content: `
            <p>[現金]</p>
            <li>出金が承認されると、翌月15日に入金処理されます。ただし、海外送金により最長で7日以上かかることがあります。</li>
            <li>出金申請金額は、送金手数料などにより実際の受取り額とは異なります。</li>
            <li>詳細履歴確認で、より詳しい進行状況を確認できます。</li>`,
        contentNexonPoint: `
          <p>[NEXONポイント]</p>
          <li>NEXONポイント交換の場合には申請した月の21日以降、10営業日以内を目安に順次チャージされます。</li>
          <li>順次処理を行うため、NEXONポイントのチャージタイミングはクリエイターによって異なる場合があります。</li>`,
      },
    },
    requestExchangePoint: 'ポイント出金申請',
    businessRegularProfit: '事業者 {year}年 {month}月定期収益',
    withdrawPersonBalance: 'ポイント出金済',
    withdrawBusinessBalance: '事業者残高出金',
    global: {
      table: {
        column: {
          regiDate: '申請日',
          status: '状況',
          withdrawPoint: '出金申請ポイント',
          withdrawAmount: '出金申請金額',
          orderNo: '注文番号',
          type: '申請タイプ',
        },
      },
    },
  },
  // page - 출금 정보
  userInfo: {
    needVerifiedId:
      '本人確認が完了したIDのみご利用いただけます。<br/>マイ情報>マイ情報管理>個人情報変更で本人確認後、ご利用ください。',
    removeWithdrawalInfo: '出金情報を本当に削除しますか？入力された出金情報はすべて削除されます。',
    underReview: 'まだ処理されていない事業者申請内訳があります。処理中は出金情報の削除はできません。',
    processingCompleted: '処理が完了しました。',
  },
  // page - global
  global: {
    title: 'ポイント出金申請',
    titlePoint: 'NEXONポイント交換申請',
    subTitle: '出金申請',
    subTitlePoint: '交換申請',
    mainText: `ポイントを現金で出金できます。`,
    mainTextForNexonPoint: `<span>ポイントは現金での出金、</span> またはNEXONポイントへの交換ができます。`,
    subText: `<span>ご案内事項を確認の上、出金申請をクリックすると</span>次のステップに進みます。`,
    applyGuide: '出金申請のご案内',
    applyGuidePoint: 'NEXONポイント交換申請案内',
    applyBtn: '出金申請',
    applyBtnPoint: '申請する',
    detailButton: '詳細履歴確認 ',
    available: '保有中の {pointName}',
    withdrawPointInput: '申請するポイント数',
    withdrawNjPointInput: '交換申請ポイント入力',
    withdrawAmount: '申請金額',
    withdrawAmountPoint: 'NEXONポイント交換申請金額',
    transferFeeDescription: '送金手数料などにより、実際の受取り額は異なる場合があります。',
    transferFeeDescriptionPoint: '申請した金額がNEXONポイントとして支給されます。',
    confirmWithdrawCaution: 'ポイント出金に関する注意事項をすべて確認しました。',
    confirmWithdrawCautionPoint: 'ポイント交換に関する注意事項をすべて確認しました。',
    withdrawCaution: '出金に関する注意事項',
    pointCaution: 'NEXONポイント交換に関する注意事項',
    maxAmount: '最大金額',
    inputPlaceholder: '{point}{unit}ずつ入力可能',
    withdrawCautionDescriptions: {
      1: '1回につき最低{currency} {min} ~ {currency} {max}まで申請できます。',
      2: 'ポイント出金は一度申請するとキャンセルができません。',
      3: '送金手数料などを除いて出金されるため、申請金額と受取り額は異なることがあります。',
      4: 'ポイント積立時の不正行為や口座などの申請情報に問題がある場合は、出金申請が拒否される場合があります。',
      5: '申請履歴はポイント出金履歴より確認できます。',
      6: `
        <li>- リワードポイントの収益化に関する手続き（以下「本手続き」といいます）にあたり、お客様からご提供いただく情報（個人情報を含み、以下「ご提供情報」といいます）は、本手続き及びお客様に対するサポート手続きにのみ利用し当社の
          <a
            href="https://company.nexon.co.jp/support/privacypolicy.html?_gl=1*1vcfzsa*_gcl_au*MTc5MzY4NDg5LjE3MDA4MDc3MzA"
            target="_blank"
          >プライバシーポリシー</a>に基づいて管理いたします。<br />
          なお、ご提供情報は、当社が収益化手続きを委託するTipalti, Inc.（アメリカ合衆国カリフォルニア州に所在）に提供いたします。<br />
          Tipalti, Inc.においては、OECDプライバシーガイドライン8原則に対応する措置を講じています。
        </li>
        <li>
          - アメリカ合衆国カリフォルニア州の個人情報程に関する制度に関する情報については、日本の個人情報保護委員会が公表している
          <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/" target="_blank">文書</a>をご参照ください。
        </li>
        <li>
          - ご提供情報は正確に入力してください。入力内容の不備に起因してお客様に生じる不利益につきましては当社は一切の責任を負いませんので予めご了承ください。
        </li>
      `,
    },
    withdrawPointCautionDescriptions: {
      1: '1回に {min}{currency} ~ {max}{currency}まで申請できます。',
      2: '申請後のキャンセルはできません。',
      3: 'ポイント獲得時に不正行為が発覚した場合、出金申請が拒否される場合があります。',
      4: '申請履歴はポイント出金履歴からご確認いただけます。',
    },
    modalHeader: '出金申請方法選択',
    modalTitle: '出金申請方法を選択してください。',
    modalDesc: `申請は毎月1回のみ可能です。<br />申請方法は慎重にご検討の上、選択してください。`,
    cash: '現金',
    nexonPoint: 'NEXONポイント',
    nextStep: {
      1: '「次へ」をクリックすると、出金情報の入力ステップに進みます。',
      2: '出金申請ガイドを必ず事前にご確認の上、出金情報入力に進んでください。',
      3: '出金申請ガイド',
    },
    nextStepForPoint: {
      1: `「申請する」ボタンをクリックすると、NEXONポイント交換申請が完了します。`,
      2: '交換申請に関する注意事項は以下のガイドからもご確認いただけます。',
      3: '申請ガイド',
    },
    withdrawFail: 'エラーが発生しました。<br/>再度お試しください。',
    withdrawSuccessTitle: 'ポイント出金申請をリクエストしました。',
    withdrawSuccessTitlePoint: 'ポイント交換申請をリクエストしました。',
    withdrawSuccessDesc:
      '申請リクエストは最長で30分かかることがあり、<br />ポイント出金履歴より進行状況を確認できます。',
    withdrawSuccessDescPoint:
      'NEXONポイントは当月21日以降に承認を経て申請したアカウントに支給されます。<br />進行状況はポイント出金履歴からご確認ください。',
    notAvailableCurrency: '申し訳ございません。<br/>ログインされたアカウントではご利用できないポイントです。',
    notAvailableAge: '申し訳ございません。<br/>出金申請は満14歳以上のアカウントのみご利用できます。',
    notAvailablePeriod: '現在、出金申請期間ではありません。<br/>出金申請期間をご確認の上、申請してください。',
    notAvailableEmail:
      'メール認証がお済みでないアカウントです。<br/>出金申請はメール認証されたアカウントのみご利用できます。<br/>ネクソンアカウント設定メニューで承認を行ってください。',
    notAvailableWithdrawCount: '申し訳ございません。<br/>当月の出金申請回数を超えたため、出金申請ができません。',
    notAvailableEnoughPoint: '申し訳ございません。<br/>出金申請できるポイント残高が不足しています。',
    otpGuide:
      '安全にご利用いただくため本人確認情報登録の前に<br/>ワンタイムパスワード設定が必要です。<br/>ワンタイムパスワードを設定しますか？',
    notFinishedReviewAuth: '登録された本人確認情報を確認中です。<br/>確認処理が完了すると、修正できます。',
    notRegisteredAuth:
      '本人確認情報が登録されていません。<br/>本人確認情報を登録し、登録された情報が承認されると、<br />出金申請を行うことができます。<br/>本人確認情報を登録しますか？',
    rejectedAuth:
      '登録された本人確認情報が差戻しされました。<br/>出金申請は本人確認情報を登録し、登録された情報が承認されると、<br />出金申請を行うことができます。<br/>本人確認情報を修正しますか？',
    reApplicationAuth:
      '登録されている本人確認情報の更新が必要です。<br/>登録されたメールアドレス宛にお送りしたメールをご確認の上、本人確認情報を更新してください。<br/>本人確認情報を更新しますか？',
    confirmingAuth:
      '現在、登録された本人確認情報を確認中です。<br/>登録された情報が承認された後、出金申請を行ってください。',
    noneOtp:
      '安全にご利用いただくため、<br />出金申請の前にワンタイムパスワード設定が必要です。<br />ワンタイムパスワードを設定しますか？',
    validation: {
      minWithdrawPoint: '最低 {minValue}{unit}以上から申請できます。',
      maxWithdrawPoint: '最大 {maxValue}{unit}まで申請できます。',
      amountUnit: '{unitValue}{unit} 単位で申請できます。',
      notHasEnoughPoint: '入力したポイント数が保有ポイントを超えています。',
      withdrawing: 'しばらくお待ちください。処理中の申請履歴があります。',
      notAvailableApplication:
        '申し訳ございません。<br/>出金申請ができないアカウントです。<br/>出金申請のご案内事項をご確認ください。',
      commonError: '申し訳ございません。<br/>原因不明のエラーが発生しました。時間をおいて再度お試しください。',
    },
    exchangeRate: 'ポイントレート {unitValue}{unit} = {currency} 1',
    exchangePointRate: 'ポイントレート {unitValue}{unit} = NEXONポイント 1{currency}',
  },
  error: {
    point: {
      1: 'サービスメンテナンス中のため、ポイント出金申請ができません。<br/>メンテナンス終了後、再度ご利用ください。',
      3001: '本人確認が完了したIDのみご利用いただけます。<br/>マイ情報>マイ情報管理>個人情報変更で本人確認後、ご利用ください。',
      3002: '満14歳に満たないお客様はポイント交換申請ができません。',
      3004: 'ポイント残高が不足しているため、交換申請ができません。',
      3005: 'ポイント出金申請は月に1度のみ申請できます。<br/>当月はすでに申請済の履歴があるため、申請できません。<br/>申請履歴はポイント交換履歴でご確認ください。',
      3006: 'ポイント残高が不足しているため、交換申請ができません。',
      3008: 'ポイント出金申請はユーザー情報及び受取口座',
      3009: '事業者ユーザーはポイント交換申請ができません。<br>事業者は毎月1日に前月獲得ポイントが自動的に交換申請され、<br/>電子税金計算書により収入を受け取れます。',
      3013: '最低 {minValue}{unit}以上から申請できます。',
      3015: '申し訳ございません。<br/>出金申請期間外です。<br/>出金申請期間をご確認のうえ、申請してください。',
      3017: '등록된 출금정보의 이름이 현재 회원정보와 일치하지 않습니다.<br>출금정보를 업데이트 해주세요.',
      default:
        '申し訳ございません。<br/>原因不明のエラーのため、ポイント出金申請ができません。<br/>時間をおいて再度ご利用ください。',
    },
    pointHistory: {
      0: 'ポイント履歴がありません。',
      1: 'サービスメンテナンス中のため、<br/>ポイント履歴の確認ができません。<br/>メンテナンス終了後、再度ご利用ください。',
      default:
        '申し訳ございません。<br/>原因不明のエラーのため、履歴を表示できません。<br/>時間をおいて再度ご利用ください。',
    },
    exchangeHistory: {
      0: 'ポイント出金履歴がありません。',
      1: 'サービスメンテナンス中のため、ポイント出金履歴の確認ができません。<br/>メンテナンス終了後、再度ご利用ください。',
      default:
        '申し訳ございません。<br/>原因不明のエラーのため、履歴を表示できません。<br/>時間をおいて再度ご利用ください。',
    },
    search: {
      day: '照会期間は最大31日です。<br/>日付を調整してください。',
      month: '照会期間は最大12か月です。<br/>日付を調整してください。',
    },
    common: {
      temporaryError: '一時的なエラーが発生しました。<br/>時間をおいて再度ご利用ください。',
      needLogin: 'ログインページに移動しますか？',
      needIdentity: '本人確認をお願いします。',
      serviceNotAvailable: 'サービスをご利用いただけません。',
      notPossiblePointConversion: 'ポイント交換申請ができません。',
      retry: 'もう一度お試しください。',
      serviceConnectionError: 'サービスに接続しづらい状況が発生しています。<br/>時間をおいて再度お試しください。',
      maintenance: 'メンテナンス中です。',
      maintenanceDescription: 'サービスメンテナンス中です。<br/>ご不便をおかけし、誠に申し訳ございません。',
      errorPath: 'パスが正しくありません。',
    },
    // 임시 에러 메시지
    temp: {
      global: '申し訳ございません。<br/>出金申請ができません。<br/>出金申請は6月中にオープンする予定です。',
    },
  },
};
